import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './RecordList.module.css';
import ImageWithFallback from '../GenericComponents/ImageWithFallback';
import * as ccUtils from '../CC/utils';
import { useCCContext } from '../CC/CCContext';
import { getImages } from '../Result/getImages';

interface RecordListProps {
    record: any;
    index: number;
    handleLinkClick: (event: React.MouseEvent, index: number) => void;
}

const RecordList: React.FC<RecordListProps> = ({ record, index, handleLinkClick }) => {
    const { t } = useTranslation();
    const ctx = useCCContext();

    function getDefaultRow(record: any, label: string, fieldName: string, defaultValue: string = ""): JSX.Element | null {
        function getNestedValue(obj: any, path: string): any {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        }

        let fieldValue = getNestedValue(record?.data?.record, fieldName);

        if (typeof fieldValue === 'object' && fieldValue !== null) {
            fieldValue = JSON.stringify(fieldValue);
        }

        if (!fieldValue && !defaultValue) return null;

        return (
            <div className={styles.row}>
                <span className={styles.taglabel}>{label} : </span>
                <span className={styles.tagValue}>{fieldValue ?? defaultValue}</span>
            </div>
        );
    }

    function getDefaultRowHyperlink(record: any, label: string, fieldName: string, hyperlinkfield: string = "", defaultValue: string = ""): JSX.Element | null {
        function getNestedValue(obj: any, path: string): any {
            return path.split('.').reduce((acc, part) => acc && acc[part], obj);
        }

        let fieldValue = getNestedValue(record?.data?.record, fieldName);

        const handleOnClick = (label: string, value: string, e: React.MouseEvent) => {
            e.stopPropagation();
            e.preventDefault();
            ccUtils.customSearch(ctx, '/record/' + hyperlinkfield, '', '' + value + '', label + ' : ' + value);
        };

        // If fieldValue doesn't exist and no defaultValue is provided, return null
        if (!fieldValue && !defaultValue) return null;

        return (
            <div className={styles.row}>
                <span className={styles.taglabel}>{label} : </span>
                {fieldValue
                    ? <span className={styles.hyperlink} onClick={(e) => handleOnClick(label, fieldValue, e)}>{fieldValue}</span>
                    : defaultValue}
            </div>
        );
    }

    function getPersonnes(record: any, tag: keyof typeof record.data.record) {
        const elements = record?.data?.record?.[tag];
        if (!elements) return null;

        // Convert to array if not already
        const elementArray = Array.isArray(elements) ? elements : [elements];

        // Sorting logic (if required)
        elementArray.sort((a, b) => {
            const keyA = a.RoleTypeID + ',' + a.DisplayOrder;
            const keyB = b.RoleTypeID + ',' + b.DisplayOrder;
            return keyA.localeCompare(keyB);
        });

        const handleOnClick = (e: React.MouseEvent, name: string) => {
            e.preventDefault();
            e.stopPropagation();
            ccUtils.customSearch(ctx, '/record/creatorname,/record/conxother', '', '[' + name + ']', t('Constituent') + ' : ' + name);
        };

        const rows = elementArray.map((element: any, index) => {
            const { Role, [tag]: tagValue, displaydate } = element;
            return (
                <div className={styles.row} key={index}>
                    <span className={styles.taglabel}>{Role} : </span>
                    <span className={styles.authName} onClick={(e) => handleOnClick(e, tagValue)}>{tagValue}</span>
                    {displaydate && <span className={styles.authDate}>&nbsp;({displaydate})</span>}
                </div>
            );
        });

        if (rows.length === 0) return null;

        return <>
            <div>
                {/* {t("record_personnes_institutions")} */} 
            </div>
            <div>
                {rows}
            </div>
        </>
    }

    
    let imageUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}/nondisponible.cci&width=220&bg=ffffff`; //todo: noimage
    const allImages = getImages(record);
    if ((allImages as any)["list"]?.length > 0) {
        imageUrl = (allImages as any)["list"][0]?.url;
    }
    const invNo = record?.data?.record?.objectnumber;
    const recordDataAsString = JSON.stringify(record?.data?.record, null, 2); // Converts the object to a JSON string with pretty print

    return (
        <div>
            {false && <textarea value={recordDataAsString}></textarea>}

            <a
                href={`${window.location.pathname}?action=search&field=/Record/ObjectNumber&label=N°%20de%20gestion&value=${invNo}`}
                className={styles.RecordList}
                key={index}
                onClick={(event) => handleLinkClick(event, index)}
                onMouseDown={e => e.preventDefault()}
            >
                <div className={styles.listViewPanel}>
                    <div className={styles.ccListviewRecordTable}>
                        <div className={styles.ccListviewRecordImage}>
                            {imageUrl && <ImageWithFallback src={imageUrl} alt={invNo} placeholder="images/nondisponible.jpg" maxWidth={220} />}
                        </div>
                        <div className={styles.ccListviewRecordText}>

                            {getDefaultRow(record, t("record_title"), "title.title")}
                            {getDefaultRow(record, t("record_objectnumber"), "objectnumber")}
                            {getDefaultRow(record, t("record_classification"), "classification")}
                            {getDefaultRowHyperlink(record, t("record_auteur"), "auteur.auteur", "auteur")}
                            {getPersonnes(record, 'creator')}
                            {getDefaultRow(record, t("record_dated"), "dated")}
                            {getDefaultRow(record, t("record_collection"), "webcollection")}
                            

                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}

export default RecordList;
